import http from '../http-common'

export default class RoleServices {
    async showRoles(data) {
        let res = http.get("v1/role/Roles");
        return res;
    }
}